import { useMsal } from "@azure/msal-react";
import { Button } from "primereact/button";
import React from "react";

export const AccessDenied = () => {
  const { instance } = useMsal();

  const Logout = async () => {
    try {
      await instance.logoutRedirect();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="triangle-image">
        <img src={import.meta.env.VITE_LOGIN_BACKGROUND_URL} alt="Background Image" />{" "}
      </div>
      <div className="w-full absolute top-0 bottom-0 left-0 right-0 m-auto flex items-center justify-center h-auto flex-col">
        <div className="bg-grey logout-img">
          {" "}
          <img src="/assets/icons/unauth.svg" />
        </div>
        <strong className="my-5 text-purple">Sorry, you are not authorized to access this page.</strong>
        <Button className="border-0 bg-transparent link-btn" label="Logout" onClick={Logout}>
          {" "}
        </Button>
        <div className="text-purple font-bold"></div>
      </div>
    </>
  );
};
